import EastIcon from '@mui/icons-material/East'
import NotificationsIcon from '@mui/icons-material/Notifications'
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye'
import WatchLaterIcon from '@mui/icons-material/WatchLater'
import { GetPaymentResultDTO } from '@src/api/@types/GetPaymentResultDTO'
import { formatDateLanguage } from '@src/services/Formatter'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Notification from './Notification'
import DelayNotificationContainer from './NotificationDelayed'

interface Props {
  isManualPayment?: boolean
  lateAmountWithInterest: string
  selectedPayment?: GetPaymentResultDTO | null
  goToAddPayment?: () => void; 
  hideButton?: boolean;
}
const NotificationContainer: FC<Props> = ({
  isManualPayment,
  lateAmountWithInterest,
  selectedPayment,
  goToAddPayment,
  hideButton = false
}) => {
  const [showNewNotification] = useState(true)

  const { t } = useTranslation()

  const renderNewNotification = () => (
    <Notification
      title={
        <>
          <NotificationsIcon /> {t('notifications.new')}
        </>
      }
      description={t('notifications.new')}
      icon={<RemoveRedEyeIcon sx={{fontSize:'2rem'}}/>}
    />
  )

  const renderLatePaymentNotification = () => (
    <DelayNotificationContainer
      title={t('notifications.lateSum')}
      description={
        <>
          <WatchLaterIcon sx={{fontSize:'2rem'}}/> {lateAmountWithInterest}
        </>
      }
      buttonTitle={t('notifications.updatePayment')} 
      icon={<EastIcon className="retard-icon" />}
      buttonAction={goToAddPayment}
      showButton={!hideButton} 
    />
  )

  const renderScheduledPaymentNotification = () => (
    <Notification
      title="Scheduled Payment"
      description={`${t('notifications.datePayment')}: ${formatDateLanguage(selectedPayment?.plannedOnDateUTC ?? '')}`}
      icon={<WatchLaterIcon sx={{fontSize:'2rem'}}/>}
      amount={selectedPayment?.amount}
    />
  )

  return (
    <>
      <div style={{  width: "100%", maxWidth: "730px", marginTop: "0px !important"}}>
        {!showNewNotification && !renderNewNotification()}
        {parseFloat(lateAmountWithInterest) > 0 && renderLatePaymentNotification()}
        {isManualPayment && renderScheduledPaymentNotification()}
      </div>
    </>
  )
}

export default NotificationContainer
